<template>
  <div>
    <Menu />

    <div id="logs-monitoramento" class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Últimas visualizações"
            description="Monitoramento de utilização do sistema"
            url="/administracao"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-5271"
            pageIdentifier="ultimas-visualizacoes"
          />
        </div>
      </div>

      <div class="logs-card logs-filtro-periodo">
        <div class="row align-items-end">
          <div class="col-lg-5 col-md-6">
            <div class="form-group">
              <label>Período</label>

              <date-range-picker
                ref="picker"
                v-model="periodoSelecionado"
                :opens="'right'"
                :locale-data="localeData"
                :min-date="minDate"
                :max-date="maxDate"
                :auto-apply="true"
                :ranges="ranges"
                class="logs-date-range"
              >
                <template v-slot:input="picker">
                  {{ formatarPeriodo(picker.startDate, picker.endDate) }}
                </template>
              </date-range-picker>
            </div>
          </div>

          <div class="col-lg-2 col-md-3">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-primary btn-block logs-btn-buscar"
                @click="buscar"
              >
                <i class="icofont-search"></i>
                Buscar
              </button>
            </div>
          </div>

          <div class="col-lg-5 col-md-3">
            <div class="form-group logs-exportar">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="loadingExportar"
                @click="exportar"
              >
                <b-spinner
                  v-if="loadingExportar"
                  small
                  class="mr-1"
                ></b-spinner>

                <i v-else class="icofont-download"></i>

                Exportar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <ul class="nav nav-tabs logs-tabs">
        <li v-for="tab in tabs" :key="tab.value" class="nav-item">
          <a
            href="#"
            class="nav-link"
            :class="{ active: abaAtiva === tab.value }"
            @click.prevent="abaAtiva = tab.value"
          >
            {{ tab.label }}
          </a>
        </li>
      </ul> -->

      <!-- <div class="logs-tab-content"> -->
      <VisaoGeral
        v-if="abaAtiva === 'visao-geral'"
        :filtros-periodo="filtrosPeriodo"
        :equipes="equipes"
        :profissionais="profissionais"
        :funcionalidades="funcionalidades"
        :loading-equipes="loadingEquipes"
        :loading-profissionais="loadingProfissionais"
        :loading-funcionalidades="loadingFuncionalidades"
        @atualizar-profissionais="carregarProfissionais"
      />

      <Funcionalidades
        v-if="abaAtiva === 'funcionalidades'"
        :filtros-periodo="filtrosPeriodo"
        :equipes="equipes"
        :profissionais="profissionais"
        :funcionalidades="funcionalidades"
        :loading-equipes="loadingEquipes"
        :loading-profissionais="loadingProfissionais"
        :loading-funcionalidades="loadingFuncionalidades"
        @atualizar-profissionais="carregarProfissionais"
      />

      <Profissionais
        v-if="abaAtiva === 'profissionais'"
        :filtros-periodo="filtrosPeriodo"
        :equipes="equipes"
        :profissionais="profissionais"
        :funcionalidades="funcionalidades"
        :loading-equipes="loadingEquipes"
        :loading-profissionais="loadingProfissionais"
        :loading-funcionalidades="loadingFuncionalidades"
        @atualizar-profissionais="carregarProfissionais"
      />

      <BaixaAdocao
        v-if="abaAtiva === 'baixa-adocao'"
        :filtros-periodo="filtrosPeriodo"
        :equipes="equipes"
        :profissionais="profissionais"
        :funcionalidades="funcionalidades"
        :loading-equipes="loadingEquipes"
        :loading-profissionais="loadingProfissionais"
        :loading-funcionalidades="loadingFuncionalidades"
        @atualizar-profissionais="carregarProfissionais"
      />
      <!-- </div> -->
    </div>

    <Footer />
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import VisaoGeral from './tabs/VisaoGeral'
import Funcionalidades from './tabs/Funcionalidades'
import Profissionais from './tabs/Profissionais'
import BaixaAdocao from './tabs/BaixaAdocao'

export default {
  name: 'UltimasVisualizacoes',
  metaInfo: {
    title: 'Últimas visualizações',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    DateRangePicker,
    VisaoGeral,
    Funcionalidades,
    Profissionais,
    BaixaAdocao,
  },
  data() {
    const hoje = new Date()

    return {
      abaAtiva: 'visao-geral',
      periodoSelecionado: {
        startDate: hoje,
        endDate: hoje,
      },
      filtrosPeriodo: {
        periodo: 'personalizado',
        data_inicial: this.formatarDataApi(hoje),
        data_final: this.formatarDataApi(hoje),
      },
      equipes: [],
      profissionais: [],
      funcionalidades: [],
      loadingEquipes: false,
      loadingProfissionais: false,
      loadingFuncionalidades: false,
      loadingExportar: false,
      localeData: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'S',
        customRangeLabel: 'Intervalo personalizado',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      ranges: {
        Hoje: [hoje, hoje],
        'Esta semana': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay())
          ),
          hoje,
        ],

        'Semana passada': [
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 7)
          ),
          new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() - 1)
          ),
        ],

        'Este mês': [new Date(hoje.getFullYear(), hoje.getMonth(), 1), hoje],

        'Mês passado': [
          new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1),
          new Date(hoje.getFullYear(), hoje.getMonth(), 0),
        ],

        'Últimos 90 dias': [
          new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 89),
          hoje,
        ],
      },
      minDate: null,
      maxDate: hoje,
      tabs: [
        {
          value: 'visao-geral',
          label: 'Visão geral',
        },
        {
          value: 'funcionalidades',
          label: 'Funcionalidades',
        },
        {
          value: 'profissionais',
          label: 'Profissionais',
        },
        {
          value: 'baixa-adocao',
          label: 'Baixa adoção',
        },
      ],
    }
  },
  created() {
    this.carregarFiltrosTabs()
  },
  methods: {
    /**
     * Aplica o período atualmente selecionado
     * e atualiza a lista de profissionais.
     *
     * @returns {void}
     */
    buscar() {
      this.filtrosPeriodo = {
        periodo: 'personalizado',
        data_inicial: this.formatarDataApi(this.periodoSelecionado.startDate),
        data_final: this.formatarDataApi(this.periodoSelecionado.endDate),
      }

      this.carregarProfissionais()
    },

    /**
     * Carrega os dados compartilhados pelos filtros das abas.
     *
     * @returns {Promise<void>}
     */
    async carregarFiltrosTabs() {
      await Promise.all([
        this.carregarEquipes(),
        this.carregarFuncionalidades(),
      ])

      await this.carregarProfissionais()
    },

    /**
     * Carrega as equipes disponíveis para o município.
     *
     * @returns {Promise<void>}
     */
    async carregarEquipes() {
      this.loadingEquipes = true

      try {
        const { data } = await this.$api.get(
          `/app/logs/${this.$store.state.cod_ibge}/filtros/ines`
        )

        this.equipes = Array.isArray(data) ? data : data.data || []
      } catch (error) {
        console.error('Erro ao carregar equipes dos logs:', error)

        this.equipes = []
      } finally {
        this.loadingEquipes = false
      }
    },

    /**
     * Carrega as funcionalidades monitoradas ativas.
     *
     * @returns {Promise<void>}
     */
    async carregarFuncionalidades() {
      this.loadingFuncionalidades = true

      try {
        const { data } = await this.$api.get(
          `/app/logs/${this.$store.state.cod_ibge}/funcionalidades`
        )

        this.funcionalidades = Array.isArray(data) ? data : data.data || []
      } catch (error) {
        console.error('Erro ao carregar funcionalidades dos logs:', error)

        this.funcionalidades = []
      } finally {
        this.loadingFuncionalidades = false
      }
    },

    /**
     * Carrega os profissionais disponíveis considerando
     * os filtros informados pela aba ou o período global.
     *
     * @param {Object|null} filtros Filtros adicionais da aba
     * @returns {Promise<void>}
     */
    async carregarProfissionais(filtros = null) {
      this.loadingProfissionais = true

      try {
        const params = {
          ...this.filtrosPeriodo,
          ...(filtros || {}),
        }

        const { data } = await this.$api.get(
          `/app/logs/${this.$store.state.cod_ibge}/filtros/profissionais`,
          {
            params,
          }
        )

        this.profissionais = Array.isArray(data) ? data : data.data || []
      } catch (error) {
        console.error('Erro ao carregar profissionais dos logs:', error)

        this.profissionais = []
      } finally {
        this.loadingProfissionais = false
      }
    },

    /**
     * Formata o período selecionado para exibição.
     *
     * @param {Date|String} dataInicial Data inicial
     * @param {Date|String} dataFinal Data final
     * @returns {String}
     */
    formatarPeriodo(dataInicial, dataFinal) {
      if (!dataInicial || !dataFinal) {
        return 'Selecione o período'
      }

      return `${this.formatarDataBr(dataInicial)} - ${this.formatarDataBr(
        dataFinal
      )}`
    },

    /**
     * Formata uma data para o formato utilizado pela API.
     *
     * @param {Date|String} data Data que será formatada
     * @returns {String}
     */
    formatarDataApi(data) {
      if (!data) {
        return ''
      }

      const dataFormatada = new Date(data)

      const ano = dataFormatada.getFullYear()

      const mes = String(dataFormatada.getMonth() + 1).padStart(2, '0')

      const dia = String(dataFormatada.getDate()).padStart(2, '0')

      return `${ano}-${mes}-${dia}`
    },

    /**
     * Exporta os logs considerando o período atualmente aplicado.
     *
     * @returns {Promise<void>}
     */
    async exportar() {
      this.loadingExportar = true

      try {
        const response = await this.$api.get(
          `/app/logs/${this.$store.state.cod_ibge}/exportar`,
          {
            params: this.filtrosPeriodo,
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'text/csv;charset=utf-8;',
        })

        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')

        const contentDisposition = response.headers['content-disposition']

        let nomeArquivo = 'logs.csv'

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^";]+)"?/)

          if (match && match[1]) {
            nomeArquivo = match[1]
          }
        }

        link.href = url
        link.download = nomeArquivo

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)

        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Erro ao exportar logs:', error)
      } finally {
        this.loadingExportar = false
      }
    },

    /**
     * Formata uma data para exibição no padrão brasileiro.
     *
     * @param {Date|String} data Data que será formatada
     * @returns {String}
     */
    formatarDataBr(data) {
      if (!data) {
        return ''
      }

      return new Date(data).toLocaleDateString('pt-BR')
    },
  },
}
</script>

<style lang="scss">
@import './styles.scss';
</style>
